import React, { FC, memo, useMemo } from "react";

import { Container } from "./styled";
import { DataSourceInnerContainer } from "./DataSourceInnerContainer";
import { ExpandableTitle } from "../components/ExpandableTitle/ExpandableTitle";
import { ContainerLoading } from "../components/Loading/ContainerLoading";
import { DataSourceError } from "../components/DataSourceError/DataSourceError";
import { isVisibleContainer } from "../utils/isVisibleContainer";
import { useWidgetContext } from "../../Dashboard/hooks/useWidgetContext";
import { ContainerProps } from "../types";

export const DataSourceContainer: FC<ContainerProps> = memo(
  ({ layerInfo, config, elementConfig, attributes, type, renderElement }) => {
    const { dataSources, expandedContainers } = useWidgetContext(type);

    const { id, style, options } = elementConfig || {};
    const { relatedDataSource, expandable, expanded } = options || {};
    const isVisible = isVisibleContainer(id, expandable, expanded, expandedContainers);

    const dataSource = useMemo(
      () => dataSources?.find(({ name }) => name === relatedDataSource),
      [dataSources, relatedDataSource],
    );

    if (!relatedDataSource) return null;

    if (dataSource && !dataSource.features) {
      return <DataSourceError name={elementConfig.templateName} />;
    }

    const isLoading = !dataSource?.features;

    return (
      <>
        <ExpandableTitle elementConfig={elementConfig} type={type} renderElement={renderElement} />
        {!isVisible ? null : (
          <Container style={{ height: isLoading ? "3rem" : "auto", ...style }}>
            {isLoading && <ContainerLoading />}
            {dataSource?.features?.map((feature, index) => (
              <DataSourceInnerContainer
                key={index}
                feature={feature}
                layerInfo={layerInfo}
                config={config}
                elementConfig={elementConfig}
                attributes={attributes}
                isLoading={isLoading}
                type={type}
              />
            ))}
          </Container>
        )}
      </>
    );
  },
);
